import React, { useCallback } from "react"
import types from "prop-types"
import { newAction } from "utils/workflowHelpers"
import FormsyValidation from "shared/FormsyValidation"
import Action from "./Action"
import AddActionButton from "./AddActionButton"

const Actions = ({ actions, formSlug, setWorkflow }) => {
  const updateActions = useCallback(
    (updater) => setWorkflow((wf) => ({ ...wf, actions: updater(wf.actions) })),
    [setWorkflow],
  )

  const addAction = () => updateActions((prev) => [...prev, newAction()])

  const removeAction = (index) => () => {
    updateActions((prev) => {
      const next = [...prev]
      next.splice(index, 1)
      return next
    })
  }

  const changeActionType = (index) => (type) => {
    updateActions((prev) => {
      if (prev[index].type === type) return prev

      const next = [...prev]
      next[index] = newAction(type)
      return next
    })
  }

  const changeActionSubtype = (index) => (subtype) => {
    updateActions((prev) => {
      const next = [...prev]
      next.splice(index, 1, { ...prev[index], subtype })
      return next
    })
  }

  const changeActionData = useCallback((index) => (data) => {
    updateActions((prev) => {
      const next = [...prev]
      next.splice(index, 1, { ...prev[index], data })
      return next
    })
  }, [updateActions])

  return (
    <>
      <div className="flex justify-between">
        <div className="pb-5">Take the following actions:</div>
      </div>
      {
        actions.map((action, index) => (
          <Action
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            action={action}
            actionIndex={index}
            formSlug={formSlug}
            changeActionData={changeActionData}
            changeActionSubtype={changeActionSubtype(index)}
            changeActionType={changeActionType(index)}
            removeAction={removeAction(index)}
          />
        ))
      }
      <FormsyValidation
        name="actions[]"
        value={actions}
        validations={{
          isNotEmptyArray: {
            errorMessage: "Must select at least one action",
          },
        }}
      />
      <AddActionButton addAction={addAction} className="w-44" />
    </>
  )
}

Actions.propTypes = {
  actions: types.arrayOf(types.object).isRequired,
  formSlug: types.string.isRequired,
  setWorkflow: types.func.isRequired,
}

export default Actions
